import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { useClient } from 'jsonapi-react';
import LiveClassesCalendar from './LiveClassesCalendar';
import LiveClassForm from './LiveClassForm';
import ViewLiveClass from './ViewLiveClass';
import usePermission from '@/hooks/usePermission';
import LiveClassSurvey from './LiveClassSurvey';
import { useCheckIncludeProfiles } from '@/hooks/useAuthorityLevel';
import { Filter, FilterActions, FilterContent, FilterSelectNative } from '@/components/custom/filter';
import { Button } from '@/components/ui/button';
import { DashboardContent } from '@/layouts/dashboard';

function LiveClasses(props) {
  const { uri } = props;

  const [relationships, setRelationships] = useState({
    courses: []
  });
  const isStudent = useCheckIncludeProfiles({ only: ['student'] });

  const [currentLive, setCurrentLive] = useState();
  const [showLiveClassForm, setShowLiveClassForm] = useState(false);
  const [editingLiveClass, setEditingLiveClass] = useState(false);
  const [weekDays, setWeekDays] = useState([]);

  const [notAnsweredSurveys, setNotAnsweredSurveys] = useState([]);
  const [currentSurvey, setCurrentSurvey] = useState(0);

  const { t } = useTranslation();

  const filters = useFormik({
    initialValues: {
      course: 'blank'
    }
  });

  const client = useClient();

  const getRelationships = async () => {
    const { data: courses } = await client.fetch('courses/simple');

    setRelationships({
      courses: courses || []
    });
  };

  const closeLiveClassForm = () => {
    setShowLiveClassForm(false);
    setEditingLiveClass(false);
    setCurrentLive({});
  };

  useEffect(() => {
    getRelationships();
  }, []);

  const breadCrumbs = {
    title: 'Cursos e Aulas',
    nav: [
      {
        route: uri,
        name: 'Aulas ao vivo',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadCrumbs}
    >
      <Filter variant="plain">
        <FilterContent>
          <FilterSelectNative
            blankLabel={t('filter.labelSelectCourse')}
            label={t('exams.thCourse')}
            value={filters.values.course}
            onChange={e => filters.setFieldValue('course', e.target.value)}
            options={relationships.courses.map(o => ({
              id: o.id,
              name: o.title
            }))}
          />
        </FilterContent>

        {usePermission('Criar aulas ao vivo', 'Aulas ao vivo') ? (
          <FilterActions>
            <Button
              size="sm"
              wide
              onClick={() => setShowLiveClassForm(true)}
            >
              {t('liveClass.buttonCreate')}
            </Button>
            <LiveClassForm
              currentLive={currentLive}
              show={showLiveClassForm}
              onClose={closeLiveClassForm}
              editingLiveClass={editingLiveClass}
              weekDays={weekDays}
              setWeekDays={setWeekDays}
            />
          </FilterActions>
        ) : null}
      </Filter>

      <LiveClassesCalendar
        filterCourseId={filters.values.course}
        setCurrentLive={setCurrentLive}
        currentLive={currentLive}
        setEditingLiveClass={setEditingLiveClass}
        setShowLiveClassForm={setShowLiveClassForm}
        showLiveClassForm={showLiveClassForm}
        weekDays={weekDays}
        setWeekDays={setWeekDays}
        setNotAnsweredSurveys={setNotAnsweredSurveys}
      />

      {isStudent && notAnsweredSurveys.length > 0 && notAnsweredSurveys?.[currentSurvey] && (
        <LiveClassSurvey
          setCurrentSurvey={setCurrentSurvey}
          liveClassId={notAnsweredSurveys?.[currentSurvey]?.id}
          liveClassName={notAnsweredSurveys?.[currentSurvey]?.title}
        />
      )}
    </DashboardContent>
  );
}

export { LiveClasses as default, ViewLiveClass };
